
import { useEffect, useState } from 'react'
import * as fileApi from '@/api/file';
import { MarkdownRender } from '@/components/markdownRenderCore';
import useFileStore from '@/utils/fileStore';
export const MarkdownRenderInEditor = ({ content, path }: { content?: string, path?: string }) => {


    const [renderContent, setRenderContent] = useState<string>("");

    const { openFolderOrFile } = useFileStore();

    const fetchContent = async (path: string) => {
        const content = await fileApi.getRawFileResource(path)
        setRenderContent(content || "");
    }

    const onClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        const target = e.target as HTMLElement;
        if (target.tagName === 'A') {
            if (target.classList.contains('path-link')) {
                e.preventDefault();
                const path = target.getAttribute('data-path');
                if (path && openFolderOrFile) {
                    openFolderOrFile(path);
                }
            }
            else if((target as any).href?.startsWith("http")){
                // default behavior, open in new tab
            }
            else if ((target as any)?.pathname?.startsWith("/")) {
                e.preventDefault();
                const path = (target as any).pathname;
                if (path && openFolderOrFile) {
                    openFolderOrFile(path);
                }
            }
        }

    }

    useEffect(() => {
        if (content) {
            setRenderContent(content);
        } else if (path) {
            fetchContent(path);
        }
    }, [content, path]);

    return (
        <div className="markdown-content w-full h-full overflow-auto px-4 py-6 bg-white dark:bg-[#252526]">
            <MarkdownRender content={renderContent} onClick={onClick} onPathOpen={openFolderOrFile}/>
        </div>

    )
}